import { render, staticRenderFns } from "./DownloadSettings.vue?vue&type=template&id=2e1e1380&scoped=true&"
import script from "./DownloadSettings.vue?vue&type=script&lang=ts&"
export * from "./DownloadSettings.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadSettings.vue?vue&type=style&index=0&id=2e1e1380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e1380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VContainer,VDivider,VSelect,VSwitch,VTextField})
